import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const teacherLoungeGraphApi = createAsyncThunk(
    'teacherLounge/graph',
    async (requestData, { rejectWithValue }) => {
        try {
            const { params } = requestData;
            const response = await AuthAxios.get(apiRoutes.teacherLoungeGraph(), { params })
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const initialState = { result: [], loading: false, error: null, message: "" }
const teacherLoungeGraphSlice = createSlice({
    name: 'teacherLoungeGraph',
    initialState: initialState,
    reducers: {
        resetTeacherLoungeGraph: () => initialState,
    },
    extraReducers: (builder) => {
        // eslint-disable-next-line
        builder.addCase(teacherLoungeGraphApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(teacherLoungeGraphApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result || action?.payload?.data || action?.payload
            state.message = action?.payload?.message
        })
        builder.addCase(teacherLoungeGraphApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetTeacherLoungeGraph } = teacherLoungeGraphSlice.actions;
export const teacherLoungeGraphReducer = teacherLoungeGraphSlice.reducer;
